import type { Notification } from '../store/slices/uiSlice';

const mockNotifications: Notification[] = [
  {
    id: 'notif1',
    type: 'trade',
    title: 'Trade Completed',
    message: 'Your P2P trade for 1,000 USDT has been completed successfully.',
    read: false,
    createdAt: '2024-12-21T10:00:00Z',
    actionUrl: '/p2p',
  },
  {
    id: 'notif2',
    type: 'deposit',
    title: 'Deposit Confirmed',
    message: 'Your deposit of 5,000 USDT has been confirmed and credited to your wallet.',
    read: false,
    createdAt: '2024-12-21T09:30:00Z',
    actionUrl: '/wallet',
  },
  {
    id: 'notif3',
    type: 'security',
    title: 'New Login Detected',
    message: 'A new login was detected from Lagos, Nigeria. If this was not you, please secure your account.',
    read: true,
    createdAt: '2024-12-20T14:00:00Z',
    actionUrl: '/security',
  },
  {
    id: 'notif4',
    type: 'system',
    title: 'KYC Verification Approved',
    message: 'Congratulations! Your KYC verification has been approved. You can now trade with higher limits.',
    read: true,
    createdAt: '2024-12-19T16:00:00Z',
    actionUrl: '/profile/kyc',
  },
  {
    id: 'notif5',
    type: 'trade',
    title: 'New Trade Request',
    message: 'You have a new trade request from CryptoTrader_NG for 500 USDT.',
    read: false,
    createdAt: '2024-12-21T11:00:00Z',
    actionUrl: '/p2p',
  },
];

export const getNotifications = (userId: string): Notification[] => {
  const key = `nexara_notifications_${userId}`;
  const stored = localStorage.getItem(key);
  if (stored) return JSON.parse(stored);
  
  // Initialize with mock data for demo
  localStorage.setItem(key, JSON.stringify(mockNotifications));
  return mockNotifications;
};

export const saveNotifications = (userId: string, notifications: Notification[]) => {
  localStorage.setItem(`nexara_notifications_${userId}`, JSON.stringify(notifications));
};

export const addNotification = (userId: string, notification: Omit<Notification, 'id' | 'createdAt'>): Notification => {
  const notifications = getNotifications(userId);
  const newNotification: Notification = {
    ...notification,
    id: `notif${Date.now()}`,
    createdAt: new Date().toISOString(),
  };
  notifications.unshift(newNotification);
  saveNotifications(userId, notifications);
  return newNotification;
};

export const markAsRead = (userId: string, notificationId: string): void => {
  const notifications = getNotifications(userId);
  const notification = notifications.find(n => n.id === notificationId);
  if (notification) {
    notification.read = true;
    saveNotifications(userId, notifications);
  }
};

export const markAllAsRead = (userId: string): void => {
  const notifications = getNotifications(userId);
  notifications.forEach(n => n.read = true);
  saveNotifications(userId, notifications);
};

export const deleteNotification = (userId: string, notificationId: string): void => {
  const notifications = getNotifications(userId);
  const filtered = notifications.filter(n => n.id !== notificationId);
  saveNotifications(userId, filtered);
};

export const getUnreadCount = (userId: string): number => {
  const notifications = getNotifications(userId);
  return notifications.filter(n => !n.read).length;
};
